// CSS: {{ 'product-card.css' | asset_url | stylesheet_tag }}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.submitButtons = this.querySelectorAll('[data-type="submit"]');
    this.submitButtons.forEach(button => {
      button.addEventListener('click', this.onSubmit.bind(this));
    });
  }

  onSubmit() {
    this.submitButtons.forEach(button => button.setAttribute('disabled', true));
    const buttons = this.submitButtons;
    const items = {
      items: [{
        quantity: 1,
        id: this.dataset.productId
      }]
    };
    console.log(items);
    fetch("/cart/add.js", {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        },
        body: JSON.stringify(items)
    })
    .then(function(res){
      buttons.forEach(button => button.removeAttribute('disabled'));

      document.querySelector('.cart__toggle').click();
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    })
    .catch(err => console.error('ADD TO CART ERROR: ', err));
  }

}

customElements.define('product-card', ProductCard);